module.exports = __webpack_public_path__ + "static/media/schody42 - schody drewniane nakladane.9ac02449.jpg";